import { Component, OnInit, ViewEncapsulation, OnDestroy, signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule, FormsModule, FormGroup } from '@angular/forms';
import { MCButtonComponent, MCDialogComponent, MCFormFieldWrapperComponent, MCRadioButtonGroup, McInfoComponent, MCAccessibilityLabelDirective } from '@maslul/common-components';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MCDialog, MC_RESPONSE_STATUS_CODE, MCUtils } from '@maslul/common-services';
import { SelectItem } from 'primeng/api';
import { RequestApprovalTypeDetails, RequestApprovalTypeDetailsStore } from '../../../../../services/store/approval-type-details-store';
import { Subscription } from 'rxjs';
import { SelectedApprovalTypeComponent } from '../../components/approval-type-method/approval-types/selected-approval-type';
import { ApprovalTypeMethodSkeletonComponent } from '../../components/approval-type-method/skeleton/skeleton';
import { ApprovalTypeService } from '../../../../../services/pages/approval-type/approval-type.service';
import { SecondRequest } from '../../../../../models/request-submission-methods/approvalType/secondRequest';
import { ValidationMessageData } from '../../../../../resources/validation-massage';
import { TranslateService } from '@ngx-translate/core';
import { MIUnionRequestHttpService } from '../../../../../services/shared/union-request-http';
import { PageBaseComponent } from '../../../../shared/page-base';
import { FocusOnTabDirective } from '../../../../../services/shared/directives/focus-on-tab';
import { ApprovalTypesService } from '../../../../../services/approval-type/approval-type';
import { ProgressService } from '../../../../../services/shared/progress';


@Component({
    selector: 'mi-approval-type-method',
    imports: [
        ReactiveFormsModule,
        FormsModule,
        MCButtonComponent,
        AutoCompleteModule,
        McInfoComponent,
        MCFormFieldWrapperComponent,
        SelectedApprovalTypeComponent,
        ApprovalTypeMethodSkeletonComponent,
        InputTextModule,
        MCRadioButtonGroup,
        FocusOnTabDirective,
        MCDialogComponent,
        MCAccessibilityLabelDirective
    ],
    providers: [],
    templateUrl: './approval-type-method.html',
    styleUrl: './approval-type-method.scss',
    encapsulation: ViewEncapsulation.None
})
export class ApprovalTypeMethodComponent extends PageBaseComponent implements OnInit, OnDestroy {

    private translateService = inject(TranslateService);
    private requestApprovalTypeDetailsStore = inject(RequestApprovalTypeDetailsStore);
    private approvalTypeService = inject(ApprovalTypeService);
    private approvalTypesService = inject(ApprovalTypesService);
    private progressService = inject(ProgressService);
    private unionRequestHttpService = inject(MIUnionRequestHttpService);

    genericText = toSignal(this.translateService.stream('generic'));
    approvalTypeMethodText = toSignal(this.translateService.stream('approvalTypeMethod'));
    //myForm: FormGroup;
    //public selectedGender: string | null = null;

    chooseApprovalTypeLable = "בחירת סוג אישור";
    public customErrorMessages = ValidationMessageData.customErrorMessages
    approvalMainTypeName: string = "";
    subscription: Subscription = new Subscription();
    approvalTypeForm!: FormGroup;
    approvalTypes: SelectItem[] = [];
    typeCode: string = "";
    secondRequest: string = "";
    approvalTypeInfo: string = "";
    personalImportApTypes: SecondRequest[] = [];
    //endedLoading: boolean = false;
    approvalType: number | undefined;
    dialogProperties: MCDialog = new MCDialog();
    httpCounter = signal(1);
    isLoading = computed(() => this.httpCounter() > 0);

    ngOnInit(): void {
        this.init();
        this.httpCounter.update(v => v - 1);

    }


    init() {
        this.initApprovalTypes();
        // אם הרשימה ריקה (בקשה קיימת - הנתונים עדיין לא הגיעו), נרשם לשינויים ב-store
        if (this.personalImportApTypes.length === 0 && !this.isNewRequest) {
            this.subscription.add(
                this.requestApprovalTypeDetailsStore.getApprovalTypes().subscribe(approvalTypes => {
                    if (approvalTypes && approvalTypes.length > 0) {
                        this.initApprovalTypes();
                    }
                })
            );
        }
    }

    initApprovalTypes() {
        this.personalImportApTypes = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypes;
        this.approvalMainTypeName = this.requestApprovalTypeDetailsStore.getSnapshot().approvalMainTypeName;
        const existApprovalType = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;
        this.approvalTypes = this.personalImportApTypes.map(item => ({ value: item.apTypeId, label: item.miApTypeName || item.apTypeName }));
        const isValidExisting = existApprovalType && this.approvalTypes.some(a => a.value == existApprovalType);
        const approvalTypeId = isValidExisting ? existApprovalType : this.approvalTypes[0]?.value;
        this.approvalType = approvalTypeId;
        this.approvalTypeSelected(approvalTypeId);
    }


    setApprovalTypeDetails(approvalTypeDetails: SecondRequest) {
        const secondRequest: number = isNaN(parseInt(approvalTypeDetails.secondRequest))
            ? 0 : parseInt(approvalTypeDetails.secondRequest);
        this.requestApprovalTypeDetailsStore.setSecondRequest(secondRequest?.toString());

        const approvalTypeId: number = isNaN(parseInt(approvalTypeDetails.apTypeId))
            ? 0 : parseInt(approvalTypeDetails.apTypeId);
        this.requestApprovalTypeDetailsStore.setApprovalTypeId(approvalTypeId?.toString());
        this.requestApprovalTypeDetailsStore.setApprovalTypeName(approvalTypeDetails?.apTypeName);
        this.requestApprovalTypeDetailsStore.setIs4DigitsCustomItem(approvalTypeDetails.is4DigitsCustomItem);
    }

    setApprovalTypeInfo() {
        this.httpCounter.update(v => v + 1);

        const requestApprovalTypeDetails: RequestApprovalTypeDetails = this.requestApprovalTypeDetailsStore.getSnapshot();
        const approvalTypeKey = MCUtils.padZero(requestApprovalTypeDetails.authorityId) +
            MCUtils.padZero(requestApprovalTypeDetails.typeCode) +
            MCUtils.padZero(requestApprovalTypeDetails.secondRequest);

        this.approvalTypeService.getInfoByKey(approvalTypeKey).subscribe((info: string) => {
            this.approvalTypeInfo = info;
            this.httpCounter.update(v => v - 1);
        });
    }

    onTryChange(approvalType: any) {
        this.approvalTypeSelected(approvalType);
    }

    approvalTypeChange(approvalType: any) {
        const apTypeId = approvalType?.apTypeId || approvalType;
        const dialogText = this.approvalTypeMethodText()?.dialogApprovalChanged || this.approvalTypeMethodText()?.dialogAutorityChanged;
        if (this.approvalTypesService.isChangeAprovalType(apTypeId) && dialogText) {
            const previousApTypeId = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;
            const currentAuthorityId = this.requestApprovalTypeDetailsStore.getSnapshot().authorityId;
            setTimeout(() => { this.approvalType = previousApTypeId as any; });
            this.approvalTypesService.showDialogOnApprovalChange(this.dialogProperties, dialogText);
            const originalOkEvent = this.dialogProperties.footer!.button!.event;
            this.dialogProperties.footer!.button!.event = () => {
                originalOkEvent();
                this.progressService.resetTabs();
                this.requestApprovalTypeDetailsStore.setAuthorityId(currentAuthorityId);
                this.requestApprovalTypeDetailsStore.setApprovalTypes(this.personalImportApTypes);
                this.approvalType = apTypeId;
                this.approvalTypeSelected(apTypeId);
            };
        }
        else {
            this.approvalTypeSelected(apTypeId);
        }
    }

    initDialog() {
        this.dialogProperties.breakpoints = {
            '960px': '75vw', // ברוחב 960px ומטה, רוחב הדיאלוג יהיה 75vw
            '640px': '80vw' // ברוחב 640px ומטה, רוחב הדיאלוג יהיה 80
        };
        this.dialogProperties.id = 'mi-request-submission-methods-dialog';

    }
    clearStoreOnApprovalChange() {
        this.dialogProperties.visible = true
    }

    approvalTypeSelected(approvalType: string, _save: boolean = true) {
        const approvalTypeDetails: SecondRequest | undefined = this.personalImportApTypes.find(x => x.apTypeId == approvalType);
        if (approvalTypeDetails) {
            const isExistRequest = !this.isNewRequest && this.requestId;
            if (this.approvalTypesService.isChangeAprovalType(approvalTypeDetails.apTypeId) && !isExistRequest) {
                this.approvalTypesService.clearStoreOnApprovalChange();
            }
            this.setApprovalTypeDetails(approvalTypeDetails);
            const mainName = approvalTypeDetails.mainTypeName || approvalTypeDetails.apTypeName;
            this.approvalMainTypeName = mainName;
            this.requestApprovalTypeDetailsStore.setApprovalMainTypeName(mainName);
            if (approvalTypeDetails.typeCode) {
                this.requestApprovalTypeDetailsStore.setTypeCode(approvalTypeDetails.typeCode);
            }
            this.setApprovalTypeInfo();
            this.getApprovalTabs();

        }
    }

    getApprovalTabs() {
        this.httpCounter.update(v => v + 1);

        const approvalTypeId = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId

        this.subscription.add(this.unionRequestHttpService.GetApprovalTabs([parseInt(approvalTypeId)]).subscribe((res) => {
            if (res.code === MC_RESPONSE_STATUS_CODE.SUCCESS) {

                this.requestApprovalTypeDetailsStore.setApprovalTabs(res.data);
                this.httpCounter.update(v => v - 1);

            }

        }))
    }

    getApprovalTypeSelectedName(): string {
        //const selectedApprovalTypeId = this.getFormControl("approvalType").value;
        return this.personalImportApTypes.find(x => x.apTypeId == this.approvalType?.toString())?.miApTypeName
            || this.personalImportApTypes.find(x => x.apTypeId == this.approvalType?.toString())?.apTypeName
            || "";

    }

    showApprovalTypeInfo = (): boolean => this.approvalTypeInfo?.length > 0;

    next() {
        this.navigate('applicant-details');
    }

    back() {
        this.navigate('request-submission-methods');
    }

    haseMoreThanOneApprovalType(): boolean {
        return (this.approvalTypes.length || 0) > 1;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
